import { ApolloLink } from "./ApolloLink.js";

export const split = ApolloLink.split;
